import { EActivityType } from '@constants';
import { Button, Flex, Form, InputNumber, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { TitleWrapper } from './ActivityStudyTime.styles';

import { Icon } from '@/components/Icon';

type Props = {
  type: EActivityType;
  resetStudyTime: () => void;
};

export const ActivityStudyTime: React.FC<Props> = ({ type, resetStudyTime }) => {
  const { t } = useTranslation('DefaultTranslations');

  return (
    <Flex vertical gap={16}>
      <Flex gap={4}>
        <TitleWrapper>{t('ACTIVITY_ESTIMATED_STUDY_TIME')}</TitleWrapper>
        <Tooltip
          title={
            <Flex vertical gap={16}>
              <span>{t(`ACTIVITY_ESTIMATED_STUDY_TIME_${type}_INFO`)}</span>
              <span>{t('ACTIVITY_ESTIMATED_STUDY_TIME_INFO')}</span>
            </Flex>
          }
          placement="top">
          <Button type="link" size="small" icon={<Icon i="Information" />} />
        </Tooltip>
      </Flex>
      <Flex gap={24}>
        <Form.Item
          name={['estimatedStudyTime', 'hours']}
          label={t('ACTIVITY_ESTIMATED_STUDY_TIME_HOURS')}
          layout="horizontal">
          <InputNumber min={0} max={20} />
        </Form.Item>
        <Form.Item
          name={['estimatedStudyTime', 'minutes']}
          label={t('ACTIVITY_ESTIMATED_STUDY_TIME_MINUTES')}
          layout="horizontal">
          <InputNumber min={0} max={60} />
        </Form.Item>
        <Button type="default" onClick={resetStudyTime}>
          {t('ACTIVITY_ESTIMATED_STUDY_TIME_DELETE')}
        </Button>
      </Flex>
    </Flex>
  );
};
